import { useState } from 'react'
import { Button, Menu, MenuItem, ListItemText } from '@mui/material'
import HistoryIcon from '@mui/icons-material/History'
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff'
import ManagementSearchBar from './ManagementSearchBar'

function formatRecentTime(at) {
  if (!at) return ''
  try {
    return new Date(at).toLocaleString()
  } catch {
    return ''
  }
}

/**
 * Search bar plus Clear filters + Recent queries for list pages.
 */
export default function ListQueryToolbar({
  label,
  placeholder,
  debounceMs,
  appliedSearch = '',
  onApplySearchQuery,
  onClearFilters,
  isDefault = true,
  recent = [],
  onApplyRecent,
  children,
  maxWidth = 720,
  mb = 3,
}) {
  const [anchorEl, setAnchorEl] = useState(null)
  const menuOpen = Boolean(anchorEl)

  return (
    <ManagementSearchBar
      label={label}
      placeholder={placeholder}
      debounceMs={debounceMs}
      appliedSearch={appliedSearch}
      onApplySearchQuery={onApplySearchQuery}
      maxWidth={maxWidth}
      mb={mb}
    >
      <Button
        type="button"
        size="small"
        variant="outlined"
        startIcon={<FilterAltOffIcon />}
        onClick={onClearFilters}
        disabled={isDefault}
      >
        Clear filters
      </Button>
      <Button
        type="button"
        size="small"
        variant="outlined"
        startIcon={<HistoryIcon />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        disabled={!recent.length}
      >
        Recent
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        {recent.length === 0 ? (
          <MenuItem disabled>
            <ListItemText primary="No recent queries" />
          </MenuItem>
        ) : (
          recent.map((entry, index) => (
            <MenuItem
              key={`${entry.at}-${index}`}
              onClick={() => {
                setAnchorEl(null)
                onApplyRecent?.(entry.filters)
              }}
            >
              <ListItemText
                primary={entry.label}
                secondary={formatRecentTime(entry.at)}
              />
            </MenuItem>
          ))
        )}
      </Menu>
      {children}
    </ManagementSearchBar>
  )
}
